import { Component, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';

import { StyleClassModule } from 'primeng/styleclass';
import { AppBreadcrumb } from './app.breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { LayoutService } from './service/app.layout.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
@Component({
	selector: '[wo-topbar]',
	standalone: true,
	imports: [
		RouterModule,
		StyleClassModule,
		AppBreadcrumb,
		InputTextModule,
		ButtonModule,
		IconFieldModule,
		InputIconModule,
		ConfirmDialogModule,
	],
	template: `<div class="layout-topbar">
			<div class="topbar-start">
				<button
					#menubutton
					type="button"
					class="topbar-menubutton p-link p-trigger"
					(click)="onMenuButtonClick()">
					<i class="pi pi-bars"></i>
				</button>
				<nav wo-breadcrumb class="topbar-breadcrumb"></nav>
			</div>

			<div class="topbar-end">
				<ul class="topbar-menu">
					<!-- <li class="ml-3">
                    <p-button icon="pi pi-palette" rounded (onClick)="onConfigButtonClick()"></p-button>
                </li> -->
					<li class="ml-3">
						<p-button icon="pi pi-power-off" rounded (onClick)="onLogOut($event)"></p-button>
					</li>
				</ul>
			</div>
		</div>
		<p-confirmdialog key="logout" /> `,
})
export class AppTopbar {
	@ViewChild('menubutton') menuButton!: ElementRef;

	constructor(public layoutService: LayoutService) {}

	onMenuButtonClick() {
		this.layoutService.onMenuToggle();
	}

	onLogOut(event: Event) {
		this.layoutService.onLogOut(event);
	}

	onConfigButtonClick() {
		this.layoutService.showConfigSidebar();
	}
}
